<template>
    <FiltersLayout
        @reset="resetFilters()"
        :disabledApplyButton="disabledApplyButton"
        :disabledDeleteAllButton="disabledDeleteAllButton"
        @apply="apply()"
    >
        <DatePicker
            class="date-picker"
            v-model="date"
            @changeDate="updateDate($event)"
        />
        <Dropdown
            class="dropdown"
            v-model="status"
            name="moniboxStatus"
            :options="statusOptions"
            :neededPlaceholder="true"
            @update:modelValue="updateStatus($event)"
        />
    </FiltersLayout>
</template>

<script>
import FiltersLayout from "@/components/Modal/layouts/Filters.vue"
import DatePicker from "@/components/basic/BasicDatePicker.vue"
import Dropdown from "@/components/basic/BasicDropdown.vue"

export default {
    name: "ModalFilters",
    components: {
        FiltersLayout,
        DatePicker,
        Dropdown,
    },
    props: {
        modelValue: {
            type: Object,
        },
        statusOptions: {
            type: Array,
            required: true,
        },
        applyFunction: {
            type: Function,
        },
    },
    data() {
        return {
            date: null,
            status: {},
        }
    },
    computed: {
        disabledApplyButton() {
            const status = this.$route.query.status
            const date = this.$route.query.date

            return (
                ((!status && this.status.value === 0) ||
                    status === this.status.value) &&
                ((!date && !this.date) || date === this.date)
            )
        },

        disabledDeleteAllButton() {
            const status = this.$route.query.status
            const date = this.$route.query.date

            return !status && !date
        },
    },
    methods: {
        updateStatus(value) {
            this.status = value
        },
        updateDate(value) {
            this.date = value
        },
        resetFilters() {
            this.date = null
            this.status = this.statusOptions.find((item) => {
                return item.value == 0
            })

            this.$router.replace({
                query: {},
            })

            this.applyFunction(this.status.value, this.date)
        },
        async apply() {
            let routeQuery = { ...this.$route.query }

            // Clean query URL or add news
            if (this.date) {
                routeQuery.date = this.date
            } else {
                delete routeQuery.date
            }

            if (this.status.value) {
                routeQuery.status = this.status.value
            } else {
                delete routeQuery.status
            }

            this.$router.replace({ query: routeQuery })

            this.applyFunction(this.status.value, this.date)
        },

        checkRouteQuery() {
            if (this.$route.query.status) {
                this.status = this.statusOptions.find((item) => {
                    return item.value == this.$route.query.status
                })
            }

            if (this.$route.query.date) {
                this.date = this.$route.query.date
            }
        },
    },
    created() {
        this.checkRouteQuery()
    },
    watch: {
        "$route.query": {
            deep: true, // Nécessaire si les propriétés de l'objet sont modifiées sans recréer l'objet
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.dropdown,
.date-picker {
    min-width: 150px;
    height: min-content;
}
</style>

<style lang="scss">
@import "@/assets/scss/global.scss";
</style>
